import { load } from 'cheerio';
import Provider from '@/enums/Provider';

export function extractProductName(
    htmlSource: string,
    pathname: string,
    provider: Provider
): string {
    const $ = load(htmlSource);
    let name = '';

    switch (provider) {
        case Provider.KBS:
            //get the name from the meta title
            name = $('meta[property="og:title"]').attr('content') ||
                pathname.split('/').filter(Boolean).pop()?.replace(/-/g, ' ').replace(/\.php$/, '') || '';
            break;
        case Provider.IO:
            // io_product_title
            name = $('.io_product_title').first().text().trim();
            break;
        case Provider.ERS:
            // First, try to extract the text from an <h4> within div.title
            name = $('div.title h4').first().text().trim();
            // If no <h4> exists, fall back to the full text of div.title
            if (!name) {
                name = $('div.title').first().text().trim();
            }
            // Fallback: try to extract from <h1 class="item-title"> if available
            if (!name) {
                name = $('h1.item-title').first().text().trim();
            }
            // Final fallback: extract from the pathname
            if (!name) {
                pathname.split('/').filter(Boolean).pop()?.replace(/_/g, ' ') || '';
            }
            break;
        default:
            break;
    }
    return name;
}